import React from "react";
// import { Col, Row, Alert } from "react-bootstrap";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom"
import { withTranslation } from "react-i18next"
import { connect } from "react-redux"

import { createOng } from "../../../../store/register/ong/actions"
import { createPassager } from "../../../../store/register/passager/actions"
import { createProvider } from "../../../../store/register/provider/actions"

import UILoadingAnim from '../../../../components/UILoadingAnim/index'
import toast from 'react-hot-toast';


class Alerts extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: this.props.loading || false
    };
    setTimeout(() => this.setState({loading: false}), 3000)
  }

  componentDidUpdate() {
    if(!this.state.loading) { 
      if (this.props.mainSetState && this.props.lastStep && this.props.success) {
        toast.success("Dados enviados com sucesso!")
        return this.props.mainSetState({ current_step: this.props.lastStep })
      }
      if(!this.props.success || this.props?.errors?.length) {
        const toastOpts = {
          position: 'bottom-center',
          reverseOrder: true
        }
        this.props?.errors?.map((error, key) => toast.error(error, toastOpts))
        this.props.mainSetState({ current_step: 0 })
      }
    }
  }

  render() {
    return ((this.state.loading && <UILoadingAnim />) ||  null)
  }

  // render() {
  //   return (
  //     <Row className="alerts" id="alert">
  //       <Col>
  //         {
  //           this.props?.errors?.length &&
  //           this.props.errors.map((error, key) => {
  //             return (
  //               <Alert
  //                 key={key}
  //                 variant={this.props.success ? 'success' : 'danger'}
  //                 show={error !== null}
  //                 dismissible={true}
  //                 onClose={(closed, e) => e.target.parentElement.remove()}
  //               >{error}</Alert>
  //             )
  //           }) || ''
  //         }
  //       </Col>
  //     </Row>
  //   )
  // }

}

Alerts.PropTypes = {
  success: PropTypes.bool,
  errors: PropTypes.array
}

const mapStateToProps = (state) => {
  const errors = [...new Set([
    ...state?.Ong?.errors || null,
    ...state?.Provider?.errors || null,
    ...state?.Passager?.errors || null
  ].filter(v => v))]

  const success = [
    state?.Ong?.success || false,
    state?.Provider?.success || false,
    state?.Passager?.success || false
  ].some(v => v)

  const loading = [
    state?.Ong?.loading || false,
    state?.Provider?.loading || false,
    state?.Passager?.loading || false
  ].some(v => v)

  if (errors?.length) {
    window.scrollTo({
      top: -100, //1000
      behavior: "smooth",
    });
  }

  if(success) {localStorage.removeItem('form')} 
  return {
    loading: loading,
    success: success,
    errors: success ? ['Cadastro finalizado com Sucesso!'] : errors
  }
};

export default withTranslation()(withRouter(connect(mapStateToProps, { createOng, createPassager, createProvider })(Alerts)));